export const CHART_SETTINGS = {
  mobile: {
    height: 320,
    xAxis: {
      fontSize: 10,
      height: 60,
      tickMargin: 20,
    },
  },
  largeScreen: {
    height: 540,
    xAxis: {
      fontSize: 14,
      height: 80,
      tickMargin: 30,
    },
  },
};
